import React from "react";
import { Lock } from "lucide-react";

/**
 * One role seat limit with its current AUTHORITATIVE usage next to it.
 *
 * "Usage" is private.org_role_seat_usage: active members PLUS pending,
 * non-expired invitations (Phase 2D.2 checkpoint 2A). That is why the label
 * passed in says "Заети места" rather than "активни потребители" — an invitation
 * that has not been accepted yet still holds a licensed seat.
 *
 * The owner seat is rendered read-only and visibly locked: exactly one active
 * owner is structural, so the limit is always 1 and the database pins it with a
 * CHECK. Manager and sales accept whole non-negative integers only — and the
 * backend validates them again regardless of what happens here.
 */
export const PlatformSeatField = ({
  id,
  label,
  value,
  usage,
  usageLabel,
  editable,
  lockedHint,
  help,
  error,
  overLimit,
  onChange,
  disabled = false,
  testId,
}) => {
  const errorId = error ? `${id}-error` : undefined;
  const helpId = help ? `${id}-help` : undefined;

  return (
    <div className="qw-field qw-platform-seat">
      <label htmlFor={id}>{label}</label>
      {editable ? (
        <input
          id={id}
          className="qw-input"
          type="number"
          min="0"
          step="1"
          inputMode="numeric"
          value={value}
          disabled={disabled}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={[errorId, helpId].filter(Boolean).join(" ") || undefined}
          data-testid={testId}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <div className="qw-platform-seat-locked">
          <input
            id={id}
            className="qw-input"
            type="text"
            value={value}
            readOnly
            disabled
            aria-readonly="true"
            data-testid={testId}
          />
          <Lock size={14} strokeWidth={2} aria-hidden="true" className="qw-platform-lock" />
        </div>
      )}
      <div
        className={overLimit ? "qw-error" : "qw-help"}
        data-testid={`${testId}-usage`}
      >
        {usageLabel}: {usage}
      </div>
      {help && (
        <div className="qw-help" id={helpId}>
          {help}
        </div>
      )}
      {!editable && lockedHint && (
        <div className="qw-help" data-testid={`${testId}-locked-hint`}>
          {lockedHint}
        </div>
      )}
      {error && (
        <div className="qw-error" id={errorId} data-testid={`${testId}-error`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PlatformSeatField;
